import type { ILocation, ILocationBasicInfo } from "@/data/model/Location";

// Returns an internal name if provided; otherwise, returns a name
export function getLocationName(location: ILocationBasicInfo): string {
    if (location.internalName != null && location.internalName.length > 0) {
        return location.internalName;
    } else {
        return location.name;
    }
}
